module.exports = __webpack_public_path__ + "static/media/icone_integracao.5a5bd35e.svg";